// extracted by mini-css-extract-plugin
export default {"container":"container___g1980","center":"center___vL4_u","left":"left___eEh6N","content":"content___DYsJm"};